module.exports = __webpack_public_path__ + "img/layers-white.35d815df.svg";